import toast from '../../services/toast';
import { AmplitudeLogger, CALL_STATE_CONSTANTS, EVENTS } from '../../services/utils';
import callState from '../../store/call';
import sessionState from '../../store/session';
import { get } from 'svelte/store';
import pubsub from 'sweet-pubsub';
const startTimer = () => {
    const interval = setInterval(() => {
        const { duration } = get(callState);
        checkForTermination(duration);
        callState.update({
            duration: duration + 1
        });
    }, 1000);
    callState.update({
        timerInterval: interval
    });
};
const stopTimer = () => {
    const { duration, timerInterval } = get(callState);
    if (timerInterval && duration !== 0) {
        clearInterval(timerInterval);
        callState.update({
            duration: 0,
            timerInterval: null
        });
    }
};
export const connect = async () => {
    const { domain, host, port, protocol, username, password } = get(callState).credentials;
    // const domain = "stagingbqlv3e20.staging.pbx.pressone.co"
    // const host = "stagingbqlv3e20.staging.pbx.pressone.co"
    // const port = 7443
    // const protocol = "wss"
    // const username = "999"
    // const password = "AC0RRcV0ZdD6davLwnUnbn9tYOM="
    const socket = new JsSIP.WebSocketInterface(`${protocol}://${host}:${port}/${protocol}`);
    socket['via_transport'] = 'WSS';
    const configuration = {
        sockets: [socket],
        uri: `sip:${username}@${domain}`,
        password,
        session_timers: true,
        use_preloaded_route: false,
        contact_uri: `sip:${username}@${domain};transport=wss`
    };
    const ua = new JsSIP.UA(configuration);
    ua.on('connected', () => {
        callState.update({
            sipConnected: true
        });
    });
    ua.on('disconnected', () => {
        callState.update({
            sipConnected: false
        });
    });
    let call_sip_id = null;
    ua.on('newRTCSession', (data) => {
        const remoteAudio = document.querySelector("audio");
        if (!remoteAudio) {
            throw new Error("No audio element present. Specify a <audio /> tag any where in your file");
        }
        const callSession = data.session;
        const { state } = get(callState);
        callSession.on('connecting', async (e) => {
            var _a, _b, _c;
            console.log(">>>>>>>>>>> call connecting >>>>>>>>>>>>>>");
            // Set call_sip_id if it's an incoming call
            if (callSession.direction === 'incoming') {
                call_sip_id = ((_c = (_b = (_a = e.request) === null || _a === void 0 ? void 0 : _a.headers["X-Call-Sid"]) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.raw) || null;
            }
        });
        callSession.on('accepted', async (e) => {
            var _a, _b, _c;
            console.log(">>>>>>>>>>> call accepted >>>>>>>>>>>>>>");
            // Update call_sip_id if it's an outgoing call
            if (callSession.direction === 'outgoing') {
                call_sip_id = ((_c = (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.headers["X-Call-Sid"]) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.raw) || null;
            }
            console.log(call_sip_id);
        });
        callSession.on('ended', async (e) => {
            console.log(">>>>>>>>>>> call ended >>>>>>>>>>>>", e);
            // when the call is ended
            toast.warn("Call ended");
            const { peer, notes, duration } = get(callState);
            callState.update({
                state: CALL_STATE_CONSTANTS.IDLE,
                callActive: false,
                minimize: false
            });
            stopTimer();
            const { direction: callDirection } = callSession;
            let direction = callDirection === 'incoming' ? 'Inbound' : 'Outbound';
            const call_id = call_sip_id || callSession._request.call_id;
            pubsub.emit('call_ended', {
                direction,
                duration,
                peer,
                notes,
                call_sip_id: call_id
            });
            AmplitudeLogger.log(EVENTS.CALL_ENDED);
        });
        callSession.on('failed', async (data) => {
            console.log(">>>>>>>>>>> call failed >>>>>>>>>>>>", data);
            // when the call is rejected by the other party or missed call
            const { peer, notes, duration, callActive, state } = get(callState);
            const { direction: callDirection } = callSession;
            // do not show this toast notification when call is active or incoming calls, as call is not expected to be failed at that instance
            if (callActive) {
                return;
            }
            if (!callActive || ![CALL_STATE_CONSTANTS.INCALL, CALL_STATE_CONSTANTS.RINGING, CALL_STATE_CONSTANTS.OUTCALL].includes(state)) {
                toast.warn(`Call failed! Reason: ${data.cause}`); // toast notification
            }
            let direction;
            let event;
            if (duration === 0 && callDirection === 'incoming') {
                direction = 'Missed';
                event = 'call_missed';
            }
            else {
                direction = callDirection === 'incoming'
                    ? 'Inbound'
                    : 'Outbound';
                event = 'call_ended';
            }
            const call_id = call_sip_id || callSession._request.call_id;
            pubsub.emit(event, {
                direction,
                duration,
                peer,
                notes,
                call_sip_id: call_id
            });
            stopTimer();
            callState.reset();
            AmplitudeLogger.log(EVENTS.CALL_FAILED, data);
        });
        callSession.on('confirmed', () => {
            console.log(">>>>>>>>>>> call confirmed >>>>>>>>>>>>>>");
            const { peer } = get(callState);
            callState.update({
                state: callSession.direction === 'incoming' ? CALL_STATE_CONSTANTS.INCALL : CALL_STATE_CONSTANTS.OUTCALL,
                notes: '',
                minimize: false
            });
            startTimer();
            const call_id = call_sip_id || callSession._request.call_id;
            pubsub.emit('call_started', {
                direction: callSession.direction === 'incoming' ? 'Inbound' : 'Outbound',
                peer,
                call_sip_id: call_id
            });
            AmplitudeLogger.log(EVENTS.CALL_STARTED);
        });
        if (state === CALL_STATE_CONSTANTS.IDLE) {
            const { remote_identity = {}, direction } = callSession;
            const { display_name, _uri } = remote_identity;
            const peer = display_name || _uri._user;
            callState.update({
                callSession,
                peer,
                state: direction === 'incoming' ? CALL_STATE_CONSTANTS.RINGING : CALL_STATE_CONSTANTS.OUTGOING,
                duration: 0,
                notes: '',
            });
            const call_id = call_sip_id || callSession._request.call_id;
            if (callSession.direction === 'incoming') {
                pubsub.emit('call_ringing', {
                    peer,
                    call_sip_id: call_id
                });
                AmplitudeLogger.log(EVENTS.RINGING, { peer, call_sip_id: call_id });
            }
            else {
                pubsub.emit('call_initiated', {
                    peer,
                    call_sip_id: call_id
                });
            }
        }
        switch (callSession.direction) {
            case 'outgoing':
                callSession.connection.addEventListener('addstream', (e) => {
                    remoteAudio.srcObject = e.stream;
                    remoteAudio.play();
                });
                break;
            case 'incoming':
                callSession.on('peerconnection', (data) => {
                    data.peerconnection.addEventListener('addstream', (e) => {
                        remoteAudio.srcObject = e.stream;
                        remoteAudio.play();
                    });
                });
                break;
        }
    });
    ua.start();
    callState.update({
        ua
    });
};
export const initiateCall = (number, more_options = {}) => {
    const { sessions = [], ua, state } = get(callState);
    const { receiver = {} } = get(sessionState);
    const { business_number = {} } = receiver;
    const { phone_number } = business_number;
    const extraHeaders = [];
    if (phone_number) {
        extraHeaders.push(`X-Effective-Caller-ID-Number: ${phone_number}`);
    }
    const options = Object.assign(Object.assign({ mediaConstraints: { audio: true, video: false }, pcConfig: {
            rtcpMuxPolicy: 'negotiate',
            iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
        }, sessionTimersExpires: 1800 }, more_options), { extraHeaders });
    if (state === CALL_STATE_CONSTANTS.IDLE) {
        try {
            const call_session = ua.call(number, options);
            setTimeout(() => {
                sessions.push(call_session);
                callState.update({
                    peer: number,
                    sessions,
                    state: CALL_STATE_CONSTANTS.OUTGOING,
                    callActive: true,
                    minimize: false
                });
            }, 500);
        }
        catch (error) {
            console.log(error.toString());
        }
    }
    return null;
};
export const answer = () => {
    const { callSession, peer } = get(callState);
    const options = {
        mediaConstraints: { audio: true, video: false },
        pcConfig: {
            rtcpMuxPolicy: 'negotiate',
            iceServers: [{ urls: ['stun:stun.l.google.com:19302'] }],
        },
    };
    callSession.answer(options);
    callState.update({
        state: CALL_STATE_CONSTANTS.INCALL,
        callActive: true,
        minimize: false
    });
    pubsub.emit('answer', { mobile: peer });
};
export const hangup = () => {
    const { callSession, peer, state } = get(callState);
    if (state === CALL_STATE_CONSTANTS.IDLE) {
        return;
    }
    try {
        callSession.terminate();
    }
    catch (_) { }
    callState.update({
        state: CALL_STATE_CONSTANTS.IDLE,
        callActive: false,
        minimize: false
    });
    pubsub.emit('hangup', { mobile: peer });
};
const checkForTermination = (duration) => {
    const { receiver } = get(sessionState);
    if (!receiver) {
        return;
    }
    const { max_call_duration_limit = 0, min_call_duration_limit = 0 } = receiver;
    if (!max_call_duration_limit && !min_call_duration_limit) {
        return;
    }
    if (!!max_call_duration_limit && duration >= max_call_duration_limit) {
        hangup();
    }
    if (!!min_call_duration_limit && duration >= min_call_duration_limit) {
        const limit = !!max_call_duration_limit ? ` This call will terminate in ${max_call_duration_limit - duration} sec` : '';
        const message = 'call limit exceeded.' + limit;
        pubsub.emit('call_limit_exceeded', { message });
    }
};
export const transfer = (number) => {
    console.log(`>>>>>>>>>>>>>> transfer ${number} >>>>>>>>>>>>>>>>>`);
    toast.warn(`Your call is being transfered`);
    const { duration, callSession, sessions = [], credentials } = get(callState);
    // if(!duration) {
    //     return;
    // }
    const { host, port } = credentials;
    const { receiver = {} } = get(sessionState);
    const { business_number = {} } = receiver;
    const { phone_number } = business_number;
    callSession.hold();
    const eventHandlers = {
        requestSucceeded: function (e) {
            console.log(">>>>>>>>>>>>> call transfered >>>>>>>>>>>>>>", e);
            pubsub.emit("call_transfer_successful", e);
            toast.success(`Call succesfully transfered`);
            AmplitudeLogger.log(EVENTS.CALL_TRANSFERED, e || {});
        },
        requestFailed: function (e) {
            console.log(">>>>>>>>>>>>> transfer failed  >>>>>>>>>>>>>>", e);
            pubsub.emit("call_transfer_failed", e);
            toast.error({ message: 'An error occured while transferring this call' });
            AmplitudeLogger.log(EVENTS.CALL_TRANSFER_FAILED, e || {});
        },
        trying: function (e) {
            console.log(">>>>>>>>>>>>> trying transfer >>>>>>>>>>>>>>", e);
        },
        progress: function (e) {
            console.log(">>>>>>>>>>>>> transfer in progress >>>>>>>>>>>>>>", e);
            e.response.body = null;
        },
        accepted: function (e) {
            console.log(">>>>>>>>>>>>> call transfer accepted >>>>>>>>>>>>>>", e);
            pubsub.emit("call_transfer_accepted", e);
            callSession.unHold();
            hangup();
        },
        failed: function (e) {
            console.log("failed", e);
            toast.error({ message: 'An error occured while transferring this call' });
        },
    };
    const extraHeaders = [`Contact: <sip:${number}@${host}:${port}>`];
    if (phone_number) {
        extraHeaders.push(`X-Effective-Caller-ID-Number: ${phone_number}`);
    }
    const options = {
        eventHandlers,
        // activeAfterTransfer: false,
        extraHeaders: [`Contact: <sip:${number}@${host}:${port}>`],
        // replaces:
    };
    const uri = new JsSIP.URI('sip', `${number}`, host, port);
    try {
        callSession.refer(uri, options);
    }
    catch (err) {
        console.dir(err);
    }
};
export const mute = (status = true) => {
    const { callSession, peer, state } = get(callState);
    if (state === CALL_STATE_CONSTANTS.IDLE) {
        return;
    }
    callState.update({
        microphone: status,
    });
    if (!status) {
        callSession.unmute();
        pubsub.emit('unmute', { mobile: peer });
        AmplitudeLogger.log(EVENTS.CALL_MUTED, { mobile: peer });
    }
    else {
        callSession.mute();
        pubsub.emit('mute', { mobile: peer });
        AmplitudeLogger.log(EVENTS.CALL_UNMUTED, { mobile: peer });
    }
};
export const hold = (status = true) => {
    const { callSession, peer, callActive } = get(callState);
    if (!callActive) {
        return;
    }
    callState.update({
        hold: status,
    });
    if (status) {
        callSession.hold();
        pubsub.emit('hold', { mobile: peer });
        AmplitudeLogger.log(EVENTS.CALL_HOLD, { mobile: peer });
    }
    else {
        callSession.unhold();
        pubsub.emit('unhold', { mobile: peer });
        AmplitudeLogger.log(EVENTS.CALL_UNHOLD, { mobile: peer });
    }
};
